import { ImporterUser } from './types'

export default function getNormalizedName(user: ImporterUser): string {
  return `${user.firstName} ${user.initials} ${user.lastNamePrefix} ${user.lastName}`.toLowerCase()
}
